import { useEffect } from 'react';

// The name every browser tab, history entry and bookmark ends with.
export const SITE_NAME = 'Auraria Furniture Exchange';

/**
 * Name the page in the browser tab (WCAG 2.4.2, Level A).
 *
 * A single-page app navigates without a document load, so the one `<title>`
 * in index.html stays on screen for every view unless each page sets its own:
 * the tab, the history entry, the bookmark and the window switcher all read
 * the same, which is the standard way this criterion is failed.
 *
 * Nothing is restored on unmount. The page being navigated to sets its own
 * title in the same commit, and putting the previous one back on the way out
 * would show a name for a page that is already gone. Preferred over Helmet,
 * which is mounted for the meta work a later team may want and is more than
 * a tab name needs.
 *
 * @param {string} [title] Omitted or empty leaves the site name alone, which
 *     is what the home page wants.
 */
export function usePageTitle(title) {
    useEffect(() => {
        document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    }, [title]);
}

export default usePageTitle;
